import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../core/services/Singleton";
import { _Exportations, _NationalizationProcessGeneralInfo } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { Modal } from "../../../../../theme/Component/Modal";
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { SelectTHConstantsValue } from "../../../../config/Componentes/SelectTHConstantsValue";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import usePaginator from "../../../../../theme/Component/usePaginator";
import { ExportationsSupport } from "../NationalizationProcessGeneralInfo/ExportationsSupport/ExportationsSupport";








export const Exportations = () => {

    const Exportations = useDataBean(_Exportations);
    const generalinfobycost = useDataBean(_NationalizationProcessGeneralInfo);
    const [fecha, setfecha] = useState<any>(null);
    const [imp, setimp] = useState<any>(null);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [pathfile, setPathFile] = useState<string>('');
    const [modaldocumentos, setModaldocumentos] = useState<any>({ name: 'cronograma', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldescargar, setDescargar] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [swich, setSwich] = useState<boolean>(null)
    const paginador = usePaginator();


    useEffect(() => {
        getLista()

    }, [])


    const getLista = () => {

        // Exportations.instance.getExportationsCatalogPorPropiedades({ State: 1 }, null).then(
        //     (resp: any) => {
        //         if (resp) {
        //             setLista(resp)
        //         }

        //     }
        // )
        Exportations.instance.getExportProcessItemsRender(paginador.page, 15, { "State": 1, Since: fecha, IDProcedureImp: imp }).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }

            }
        )
    }



    const create = () => {
        Exportations.setBean({
            State: 1,
            IDEmployee: single.getAccountID()
            // Since: single.getCurrenDate()
        });
        setSwich(false);
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        Exportations.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        Exportations.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }




    const head = [
        { title: 'ID', property: 'IDExportation', visible: true },
        { title: 'Tipo de  Item / Lote', property: 'ItemType', visible: true },
        { title: 'Usuario', property: 'EmployeeName', visible: true },
        // { title: 'Número consecutivo de registro', property: 'Item', visible: true },
        // { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Número de vuelo', property: 'FlightNumber', visible: true },
        { title: 'Declaración', property: 'Declaration', visible: true },
        { title: 'Numero de matricula de la aeronave PNC', property: 'PNC', visible: true },
        { title: 'Numero de Solicitud de Autorización de Embarque SAE', property: 'SAENumber', visible: true },
        { title: 'Fecha de registro de la solicitud SAE', property: 'SAEDate', visible: true },
        { title: 'Cantidad Unidades', property: 'QuantityUnits', visible: true },
        { title: 'Cantidad de paquetes', property: 'QuantityPackages', visible: true },
        { title: 'Peso bruto', property: 'GrossWeight', visible: true },
        { title: 'FOB Valor', property: 'FOBValue', visible: true },
        { title: 'Numero de Hoja de transferencia', property: 'NumberTransferSheet', visible: true },
        { title: 'Número de operación aérea', property: 'AerialOperationNumber', visible: true },
        { title: 'Número de declaración de exportación', property: 'ExportDeclarationNumber', visible: true },
        // { title: 'Exportacaciones Elaborado por', property: 'MadeBy', visible: true },
        // { title: 'Revisado por', property: 'ReviewedBy', visible: true },
        // { title: 'ID procesos', property: 'IDProcedureImp', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Documentos', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModaldocumentos({ ...modaldocumentos, "view": true }) } },
            { titulo: 'Descargar Reporte', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setDescargar({ ...modaldescargar, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const descargar = () => {
        generalinfobycost.instance.exportExcelWithDataExportation(Exportations.bean.IDExportation).then(
            (resp: any) => {
                // Extraer el ObjectValue
                let fullPath = resp || "";
                console.log(fullPath);
                // Obtener solo el nombre del archivo
                let fileName = fullPath.split("/").pop(); // Esto elimina toda la ruta y deja solo el nombre del archivo

                console.log(fileName);

                let path = "/quickdataerp/temp/docs/" + fileName;
                setPathFile(path);
            }
        )

    }



    return (
        <BasicPage titulo="Exportaciones">
            <div className="row">
                <div className="col-md-4">
                    <InputDate name="fecha" label="Fecha" value={fecha} setDate={(e: any) => { setfecha(e) }} />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton value="Buscar por Filtros*" icon="ri-edit-2-line" eventClick={getLista} ></BasicButton>
                </div>
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={Exportations.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="row">

                                    <div className="col-md-12">
                                        <label>Tipo de  Item / Lote</label>
                                        <SelectTHConstantsValue code={602} value={Exportations.bean.ItemType} onChange={(e: any) => { Exportations.setBean({ ...Exportations.bean, "ItemType": e }) }}></SelectTHConstantsValue>
                                    </div>
                                    {/* <div className="col-md-6">
                                        <label>Número consecutivo de registro</label>
                                        <input type="text" name="Item" className="form-control" value={Exportations.bean.Item} onChange={Exportations.handleChange} />
                                    </div> */}
                                    <div className="col-md-6">
                                        <label>Solicitud de Exportación</label>
                                        <input type="text" name="ExportRequest" className="form-control" value={Exportations.bean.ExportRequest} onChange={Exportations.handleChange} />
                                    </div>

                                    <div className="col-md-6">
                                        <label>Número de vuelo</label>
                                        <input type="text" name="FlightNumber" className="form-control" value={Exportations.bean.FlightNumber} onChange={Exportations.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Declaración</label>
                                        <input type="text" name="Declaration" className="form-control" value={Exportations.bean.Declaration} onChange={Exportations.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Numero de matricula de la aeronave PNC</label>
                                        <input type="text" name="PNC" className="form-control" value={Exportations.bean.PNC} onChange={Exportations.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Numero de Solicitud de Autorización de Embarque SAE</label>
                                        <input type="text" name="SAENumber" className="form-control" value={Exportations.bean.SAENumber} onChange={Exportations.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <InputDate name="SAEDate" label="Fecha de registro de la solicitud de autorización de embarque" value={Exportations.bean.SAEDate} setDate={(e: any) => { Exportations.setBean({ ...Exportations.bean, "SAEDate": e }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Cantidad Unidades</label>
                                        <input type="text" name="QuantityUnits" className="form-control" value={Exportations.bean.QuantityUnits} onChange={Exportations.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Cantidad de bultos</label>
                                        <input type="text" name="QuantityPackages" className="form-control" value={Exportations.bean.QuantityPackages} onChange={Exportations.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Peso bruto</label>
                                        <input type="text" name="GrossWeight" className="form-control" value={Exportations.bean.GrossWeight} onChange={Exportations.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>FOB Valor</label>
                                        <input type="text" name="FOBValue" className="form-control" value={Exportations.bean.FOBValue} onChange={Exportations.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Planilla de transferencia</label>
                                        <input type="text" name="NumberTransferSheet" className="form-control" value={Exportations.bean.NumberTransferSheet} onChange={Exportations.handleChange} />
                                    </div>
                                    <div className="col-md-6">

                                        <InputDate name="TransferSheetDate" label="Fecha de la hoja de transferencia" value={Exportations.bean.TransferSheetDate} setDate={(e: any) => { Exportations.setBean({ ...Exportations.bean, "TransferSheetDate": e }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Número de operación aérea</label>
                                        <input type="text" name="AerialOperationNumber" className="form-control" value={Exportations.bean.AerialOperationNumber} onChange={Exportations.handleChange} />
                                    </div>
                                    <div className="col-md-6">

                                        <InputDate name="AerialOperationDate" label="Fecha de operación aérea" value={Exportations.bean.AerialOperationDate} setDate={(e: any) => { Exportations.setBean({ ...Exportations.bean, "AerialOperationDate": e }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Número de declaración de exportación</label>
                                        <input type="text" name="ExportDeclarationNumber" className="form-control" value={Exportations.bean.ExportDeclarationNumber} onChange={Exportations.handleChange} />
                                    </div>
                                    <div className="col-md-6">

                                        <InputDate name="ExportDeclarationDate" label="Fecha de declaración de exportación" value={Exportations.bean.ExportDeclarationDate} setDate={(e: any) => { Exportations.setBean({ ...Exportations.bean, "ExportDeclarationDate": e }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Cliente</label>
                                        <input type="text" name="Client" className="form-control" value={Exportations.bean.Client} onChange={Exportations.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Tipo de cambio</label>
                                        <input type="text" name="ExchangeRate" className="form-control" value={Exportations.bean.ExchangeRate} onChange={Exportations.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Valor</label>
                                        <input type="text" name="Value" className="form-control" value={Exportations.bean.Value} onChange={Exportations.handleChange} />
                                    </div>
                                    {/* <div className="col-md-6">
                                        <AccountEditor idAccount={Exportations.bean.MadeBy} label="Elaborado por :" onChange={(acc: any) => { Exportations.setBean({ ...Exportations.bean, "MadeBy": acc.IDAccount }); }} />
                                    </div>
                                    <div className="col-md-6">
                                        <AccountEditor idAccount={Exportations.bean.ReviewedBy} label="Revisado por:" onChange={(acc: any) => { Exportations.setBean({ ...Exportations.bean, "ReviewedBy": acc.IDAccount }); }} />
                                    </div> */}
                                    <div className="col-md-12">
                                        <label>Observaciones</label>

                                        <textarea name="Observations" className="form-control" value={Exportations.bean.Observations} onChange={(e) => { Exportations.setBean({ ...Exportations.bean, 'Observations': e.target.value }) }} />
                                    </div>

                                </div>

                            </div>

                        </>
                    </Modal>
                    <Modal modal={modaldescargar} updateModal={setDescargar} eventModal={editaItem}>
                        <>

                            <>
                                <div className="col-md-12">
                                    <BasicButton icon="" eventClick={() => { descargar() }}>Descargar reporte Exportaciones</BasicButton>
                                    {pathfile != '' &&
                                        <div className="col-md-12">
                                            <a href={pathfile} target="_blank">Descargar Archivo</a>
                                        </div>
                                    }
                                </div>

                            </>
                        </>
                    </Modal>
                    <Modal modal={modaldocumentos} updateModal={setModaldocumentos} eventModal={editaItem}>
                        <>

                            <ExportationsSupport IDExportation={Exportations.bean.IDExportation} />
                        </>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}